import { render } from "./recaptcha.vue?vue&type=template&id=1d360e58"
import script from "./recaptcha.vue?vue&type=script&lang=js"
export * from "./recaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__